import { createClient } from "@sanity/client";

export default createClient({
    dataset:"production",
    projectId:'ldwmxk4y',
    useCdn:true,
    apiVersion:"2024-04-24"

})